import React from "react";

const WsContext = React.createContext(null);

export default WsContext;
